import React from "react";

/**
 * Процент отправки файла — для индикации в камере.
 *
 * ⚠️ Хук, а не четыре строки в каждом экране. Ритуал был одинаковый и
 * обязательно из четырёх частей: завести состояние, обнулить его В НАЧАЛЕ
 * `mutationFn`, сбросить в `onSettled`, передать в компонент. Пропусти любую —
 * и прогресс либо не появится, либо застрянет на прошлом значении; при этом
 * экран выглядит рабочим. Так и вышло: из четырёх загрузок файлов прогресс
 * получили две, а в приёмке ещё и `busy` не передавался вовсе — кладовщики
 * снимали по многу раз, потому что не видели, идёт ли отправка.
 *
 * `start()` возвращает колбэк для `uploadProgress()` из `api/client`, поэтому
 * порядок «обнулить → отслеживать» нельзя перепутать: он один.
 */
export function useUploadProgress(): {
  /** Текущий процент или `null`, когда отправки нет. */
  progress: number | null;
  /** Вызвать в начале `mutationFn`; отдаёт колбэк для `uploadProgress(...)`. */
  start: () => (percent: number) => void;
  /** Вызвать в `onSettled` — и на успехе, и на ошибке. */
  reset: () => void;
} {
  const [progress, setProgress] = React.useState<number | null>(null);
  const start = React.useCallback(() => {
    setProgress(0);
    return setProgress;
  }, []);
  const reset = React.useCallback(() => setProgress(null), []);
  return { progress, start, reset };
}
